import React from "react";
import dayjs from "dayjs";
import PaymentMethod from "../../../common/PaymentMethod";
import Search from "../../../form/Search";
import Transaction from "../../../../pages/admin/modules/Transaction";
import Badge from "../../../elements/Badge";

const SubscriptionDetails = ({ item }) => {
  return (
    <>
      <div className="bg-white border rounded-xl shadow p-4 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
          <div className="flex justify-center md:justify-start">
            <img
              src={item?.userData?.image?.url}
              alt="User"
              className="w-44 h-44 object-cover border rounded-xl"
            />
          </div>

          <div className="md:col-span-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-4 gap-x-6">
            <Detail
              label="Name"
              value={
                `${item?.userData?.firstName || ""} ${
                  item?.userData?.lastName || ""
                }` || "-"
              }
            />
            <Detail label="Email" value={item?.userData?.email || "-"} />
            <Detail
              label="Amount"
              value={item?.amount ? `₹${item.amount}` : "-"}
            />
            <Detail label="Category" value={item?.categoryType || "-"} />
            <Detail label="Type" value={item?.paymentType || "-"} />
            <Detail
              label="Date"
              value={item?.createdAt ? dayjs(item?.createdAt).format("DD MMM, YYYY") : "-"}
            />
            <Detail
              label="Payment Method"
              value={<PaymentMethod type={item?.paymentMethod} />}
            />

            <Detail
              label="Status"
              value={
                <div className="flex gap-2 items-center">
                  <Badge
                    type={item?.status === 1 ? "success" : "danger"}
                    label={item?.status === 1 ? "Active" : "Cancel"}
                  />
                </div>
              }
            />
          </div>
        </div>
      </div>
      <div className="relative px-4 py-4">
        <Transaction isSubscriptionDetails={true} subscriptionId={item?._id} />
      </div>
    </>
  );
};

const Detail = ({ label, value }) => (
  <div className="min-w-0">
    <p className="text-xs text-gray-500">{label}</p>
    <p className="text-sm font-medium text-gray-900 mt-0.5 truncate">{value}</p>
  </div>
);

export default SubscriptionDetails;
